import { Injectable, signal, WritableSignal } from '@angular/core';
import { Nullable } from 'src/app/reusables/helpers/types';


@Injectable({
    providedIn: 'root'
})
export class BrandState {

    /** Selected brand code. */
    private _selectedBrandCodeSgl: WritableSignal<Nullable<string>> = signal(null);

    /** Set brand. */
    set brandCode(value: Nullable<string>) {
        this._selectedBrandCodeSgl.set(value);
    }

    /** Get brand code. */
    get brandCode(): Nullable<string> {
        return this._selectedBrandCodeSgl();
    }
}
